<template>
    <v-dialog v-model="open" max-width="600" persistent>
        <v-card class="background-2 round-card">
            <v-card-title class="pa-3">
                <p class="pl-2 pl-xl-3">Creazione chiamate da contratto</p>
                <v-spacer></v-spacer>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pt-4 body-2">Vuoi creare un Ticket per ogni contratto selezionato?</v-card-text>
            <v-card-text class="body-2">Elementi selezionati:  <span class="body-1 font-weight-medium">{{ selected.length }}</span></v-card-text>
            <v-row class="mx-0 px-4">
                <v-col>
                    <gmh-date-picker
                        :validator="$validator"
                        v-model="model['expiration_date']"
                        label="Data di scadenza"
                        vv-name="Data di scadenza"
                        :error-messages="errors.collect('Data di scadenza')"
                    ></gmh-date-picker>
                </v-col>

                <v-col>
                    <v-switch hide-details label="Invia mail al variare dello stato" color="primary" class="margin-auto" inset v-model="model.send_mails"></v-switch>
                </v-col>
            </v-row>

            <v-row class="mx-0 px-4">
                <v-col>
                    <v-switch hide-details label="Converti Template Doc" color="primary" class="margin-auto" inset v-model="parse_doc"></v-switch>
                </v-col>
            </v-row>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text color="info" @click.native="$emit('close')">Annulla
                </v-btn>
                <v-btn text color="primary" @click.native.stop="generateTroubles()" :loading="loading">Procedi
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
	import Vue from 'vue'
	
	export default {
		name: 'generate-trouble-dialog',
		props: {
            params: Object,
            selected: Array,
            selectedIds: Array,
            modelDef: String,
            open: Boolean
		},
		data() {
            return {
                model: {},
                loading: false,
                parse_doc: false
			}
        },

        methods: {
                
            generateTroubles() {
                let ids = this.selectedIds
                this.loading = true

                this.axios.post(this.modelDef+'/generate-troubles', {ids: ids, model: this.model}).then(response => {
                    // get body data
                    let data = response.data
                    let snackmessage = ''
                    let snackcolor = ''
                    if(data.status == 'success'){
                        snackmessage = 'Chiamate create con successo'
                        snackcolor = 'success'
                    } else{
                        snackmessage = data.message
                        snackcolor = 'warning'
                    }
                    this.$store.commit('setSnackbar', {timeout: 6000, text: snackmessage, value: true, color: snackcolor})
                    if(this.parse_doc) {
                        this.$eventBusUtility.$emit('openParseDoc', this.modelDef)
                    } else {
                        this.$eventBusUtility.$emit('refreshTable_'+ this.modelDef)
                    }
                    this.loading = false
                    if(response.data.id.length == 1) {
                        this.$eventBusUtility.goTo(this.$router, 'troubles-show', response.data.id[0])
                    }
                    this.$emit('close')
                }, response => {
                    // error callback
                    this.loading = false
                })
            },            
        },

	}
</script>

